import { diaryApi as api } from './diaryApi';
export const addTagTypes = ['Diaries'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      getDiary: build.query<GetDiaryApiResponse, GetDiaryApiArg>({
        query: queryArg => ({
          url: `/diary`,
          params: {
            assetId: queryArg.assetId,
            limit: queryArg.limit,
            offset: queryArg.offset
          }
        }),
        providesTags: ['Diaries']
      }),
      addDiary: build.mutation<AddDiaryApiResponse, AddDiaryApiArg>({
        query: queryArg => ({
          url: `/diary`,
          method: 'POST',
          body: queryArg.createDiary
        }),
        invalidatesTags: ['Diaries']
      }),
      getDiaryById: build.query<GetDiaryByIdApiResponse, GetDiaryByIdApiArg>({
        query: queryArg => ({ url: `/diary/${queryArg.id}` }),
        providesTags: ['Diaries']
      }),
      updateDiary: build.mutation<UpdateDiaryApiResponse, UpdateDiaryApiArg>({
        query: queryArg => ({
          url: `/diary/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.updateDiary
        }),
        invalidatesTags: ['Diaries']
      }),
      deleteDiary: build.mutation<DeleteDiaryApiResponse, DeleteDiaryApiArg>({
        query: queryArg => ({
          url: `/diary/${queryArg.id}`,
          method: 'DELETE',
          params: { delete: queryArg['delete'] }
        }),
        invalidatesTags: ['Diaries']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type GetDiaryApiResponse = /** status 200 Diaries found. */ {
  ok?: boolean;
  data?: {
    rows?: Diary[];
    count?: number;
  };
  message?: string;
};
export type GetDiaryApiArg = {
  /** Asset ID to filter diaries */
  assetId: string;
  /** Number of records to return (default: 10) */
  limit?: number;
  /** Number of records to skip (default: 0) */
  offset?: number;
};
export type AddDiaryApiResponse =
  /** status 201 Diary has been created successfully. */ {
    ok?: boolean;
    data?: Diary;
    message?: string;
  };
export type AddDiaryApiArg = {
  /** Diary that needs to be added to the application */
  createDiary: CreateDiary;
};
export type GetDiaryByIdApiResponse = /** status 200 Diary details found. */ {
  ok?: boolean;
  data?: DiaryEntry;
  message?: string;
};
export type GetDiaryByIdApiArg = {
  /** ID of the Diary to retrieve */
  id: string;
};
export type UpdateDiaryApiResponse =
  /** status 200 The Diary's details has been updated successfully */ {
    ok?: boolean;
    data?: Diary;
    message?: string;
  };
export type UpdateDiaryApiArg = {
  /** ID of the Diary to update */
  id: string;
  /** Diary that needs to be added to the application */
  updateDiary: UpdateDiary;
};
export type DeleteDiaryApiResponse =
  /** status 200 The Diary's details has been deleted successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type DeleteDiaryApiArg = {
  /** ID of the Diary to delete */
  id: string;
  /** flag to hard delete */
  delete?: string;
};
export type Diary = {
  count?: number;
  rows?: {
    id: string;
    userId: string;
    assetId: string;
    title: string;
    description: string;
    isPrivate: boolean;
    createdAt: string;
    updatedAt: string;
  }[];
};
export type CreateDiary = {
  assetId: string;
  title: string;
  description: string;
  isPrivate: boolean;
};
export type DiaryEntry = {
  id: string;
  userId: string;
  assetId: string;
  title: string;
  description: string;
  isPrivate: boolean;
  createdAt: string;
  updatedAt: string;
};
export type UpdateDiary = {
  title: string;
  description: string;
  isPrivate: boolean;
};
export const {
  useGetDiaryQuery,
  useAddDiaryMutation,
  useGetDiaryByIdQuery,
  useUpdateDiaryMutation,
  useDeleteDiaryMutation
} = injectedRtkApi;
